module.exports = __webpack_public_path__ + "img/houseType2.15047fa0.jpg";